<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import TabNav from "@/components/TabNav.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { RouterLink, RouterView } from "vue-router";
import { useGetContact } from "./contactsCrud";
import ContactStatusDetails from "./ContactStatusDetails.vue";

const props = defineProps<{
  id: string;
}>();

const { contact, getContactStatus } = useGetContact(props.id);
</script>

<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Kontakte', to: { name: 'contacts' } },
      { label: contact?.name ?? '...' },
    ]"
  >
    <template #header>
      <h1>{{ contact?.name }}</h1>
      <ContactStatusDetails v-if="contact != null" :contact="contact" />
    </template>
    <HandleQueryStatus :query-status="getContactStatus">
      <TabNav>
        <li>
          <RouterLink
            :to="{
              name: 'editContact',
              params: { id: props.id },
            }"
            >Persönliche Daten</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{
              name: 'contactConversations',
              params: { id: props.id },
            }"
            >Gespräche</RouterLink
          >
        </li>
      </TabNav>
      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component" :contact-details="contact"></component>
        </KeepAlive>
      </RouterView>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
